import Vue from 'vue'
import Router from 'vue-router'
import Info from '@/pages/Info'
import store from '@/store'
import { Trans } from '@/i18n/Translation'
import { SET_LANGUAGE } from '@/constants/store'

Vue.use(Router)

function load (component) {
  // '@' is aliased to src/components
  return () => import(/* webpackChunkName: "[request]" */ `@/pages/${component}.vue`)
}

const router = new Router({
  routes: [
    {
      path: '/:lang',
      component: {
        template: '<router-view></router-view>'
      },
      beforeEnter: Trans.routeMiddleware,
      children: [
        { path: '', component: load('Home') },
        { path: 'help', component: load('Help') },
        { path: 'privacy-policy', component: load('PrivacyPolicy') },
        { path: 'step',
          component: load('Info'),
          children: [
            { path: '', component: Info },
            { path: 'data', component: Info },
            { path: 'breed', component: Info },
            { path: 'weight', component: Info },
            { path: 'phase', component: Info },
            { path: 'state', component: Info },
            { path: 'advice', component: Info }
          ]
        },
        {
          path: '*',
          component: load('404')
        }
      ]
    },
    {
      // Redirect user to supported lang version.
      path: '*',
      redirect (to) {
        return Trans.getUserSupportedLang()
      }
    }

  ],
  mode: 'history',
  hashBang: false,
  scrollBehavior (to, from, savedPosition) {
    if (savedPosition) {
      return savedPosition
    }
    return { x: 0, y: 0 }
  }
})

router.beforeEach((to, from, next) => {
  var langTo = to.path.split('/')[1]
  var langFrom = from.path.split('/')[1]
  if (langFrom !== '/' && langTo !== langFrom) {
    // assume this can only be the case through use of the back/forward button
    return Trans.changeLanguage(langTo).then(() => {
      store.commit(SET_LANGUAGE, langTo)
      store.dispatch('setLanguage')
      next()
    })
  }
  next()
})
export default router



// WEBPACK FOOTER //
// ./src/router/index.js